
const GetParamURL = () => {
    try {
        const location = new URL(document.location);
        const pathArray = location.pathname.replace('/proceso-suscripcion/', '').split('/');
        const params = location.searchParams;
        const productCategory = params.get('productCategory');
        const isParamsRef = params.get('ref');
        const canalDeVenta = params.get('cv');
        let formaDeContacto = '';
        let isParamsCallback = '';

        if (productCategory === 'Campanita') {
            const referrer = document.referrer;
            if (referrer.includes('club')) {
                isParamsCallback = btoa(process.env.REACT_APP_CLUB);
                formaDeContacto = 796;
            }
            else {
                isParamsCallback = btoa(process.env.REACT_APP_HOME);
                formaDeContacto = 795;
            }
        }
        else {
            isParamsCallback = params.get('callback');
            formaDeContacto = params.get('fc');
        }

        // Validar si isParamsCallback necesita ser decodificado
        const URLCallback = isParamsCallback && isValidBase64(isParamsCallback)
            ? atob(isParamsCallback) // No necesita decodificación
            : isParamsCallback; // Decodificar si es necesario

        const finalURLCallback = URLCallback || process.env.REACT_APP_LNREDIRECT;

        return {
            Modo: pathArray[0],
            Combo: pathArray[1],
            URLCallback: finalURLCallback,
            URLRef: isParamsRef,
            productCategory: productCategory,
            canalDeVenta: canalDeVenta,
            formaDeContacto: formaDeContacto,
        };
    } catch (error) {
        console.log("error catch", error);
        return {
            Modo: "",
            Combo: "",
            URLRef: ""
        }
    }
};

const isValidBase64 = (str) => {
    try {
        return btoa(atob(str)) === str;
    } catch (e) {
        console.log("catch isvalidbaese64", e)
        return false;
    }
};

export default GetParamURL;
